module.exports = __webpack_public_path__ + "img/julien.4c983160.png";